import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';

function EditProfile({ userId, profile, onClose, onUpdate }) {
  const [name, setName] = useState(profile.name);
  const [birthDate, setBirthDate] = useState(profile.birthDate);
  const [gender, setGender] = useState(profile.gender);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !birthDate || !gender) {
      alert('모든 정보를 입력해주세요.');
      return;
    }

    setLoading(true);
    try {
      await setDoc(doc(db, 'users', userId, 'profile', 'info'), {
        name,
        birthDate,
        gender,
        updatedAt: new Date().toISOString()
      });

      alert('프로필이 수정되었습니다!');
      onUpdate();
      onClose();
    } catch (error) {
      console.error('프로필 수정 실패:', error);
      alert('프로필 수정에 실패했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fade-in" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px'
    }}>
      <div className="slide-up" style={{
        backgroundColor: 'white',
        borderRadius: '24px',
        padding: '40px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        position: 'relative'
      }}>
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#8B7355'
          }}
        >
          ×
        </button>

        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✏️</div>
          <h2 style={{
            color: '#E8A87C',
            fontSize: '24px',
            marginBottom: '8px'
          }}>
            프로필 수정
          </h2>
          <p style={{
            color: '#8B7355',
            fontSize: '14px'
          }}>
            아기 정보를 수정하세요
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              아기 이름
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="예) 민준이"
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '8px'
            }}>
              생년월일
            </label>
            <input
              type="date"
              value={birthDate}
              onChange={(e) => setBirthDate(e.target.value)}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                outline: 'none',
                transition: 'border-color 0.2s',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#E8A87C'}
              onBlur={(e) => e.target.style.borderColor = '#F5E6D3'}
            />
          </div>

          <div style={{ marginBottom: '32px' }}>
            <label style={{
              display: 'block',
              color: '#8B7355',
              fontSize: '14px',
              fontWeight: 'bold',
              marginBottom: '12px'
            }}>
              성별
            </label>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '12px'
            }}>
              <button
                type="button"
                onClick={() => setGender('boy')}
                style={{
                  padding: '16px',
                  border: `2px solid ${gender === 'boy' ? '#E8A87C' : '#F5E6D3'}`,
                  backgroundColor: gender === 'boy' ? '#FAF3E8' : 'white',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: gender === 'boy' ? '#E8A87C' : '#8B7355',
                  transition: 'all 0.2s'
                }}
              >
                👦 남아
              </button>
              <button
                type="button"
                onClick={() => setGender('girl')}
                style={{
                  padding: '16px',
                  border: `2px solid ${gender === 'girl' ? '#E8A87C' : '#F5E6D3'}`,
                  backgroundColor: gender === 'girl' ? '#FAF3E8' : 'white',
                  borderRadius: '12px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  color: gender === 'girl' ? '#E8A87C' : '#8B7355',
                  transition: 'all 0.2s'
                }}
              >
                👧 여아
              </button>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '12px'
          }}>
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '16px',
                backgroundColor: 'white',
                border: '2px solid #F5E6D3',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#8B7355',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#FAF3E8'}
              onMouseOut={(e) => e.target.style.backgroundColor = 'white'}
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              style={{
                padding: '16px',
                backgroundColor: loading ? '#D4956B' : '#E8A87C',
                color: 'white',
                border: 'none',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (!loading) e.target.style.backgroundColor = '#D4956B';
              }}
              onMouseOut={(e) => {
                if (!loading) e.target.style.backgroundColor = '#E8A87C';
              }}
            >
              {loading ? '저장 중...' : '수정하기'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditProfile;
